<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology<sup>®</sup> Arm Chair</h2>
        <!-- <h3></h3> -->

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml" @openModal="openModal" @isVideo="initModal">
            <photo
              @setFeature="setFeatureImg"
              @isVideo="initModal"
              src="Arm Chair_Contrology_Video_Thumb@1x.jpg"
              src2="Arm Chair_Contrology_Video_Thumb@2x.jpg"
              alt="Video of Contrology Arm Chair"
              video
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-chair1@1x.jpg"
              src2="contrology-chair1@2x.jpg"
              alt="Photo of Contrology Arm Chair"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-chair2@1x.jpg"
              src2="contrology-chair2@2x.jpg"
              alt="Side-view photo of Contrology Arm Chair"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-chair3@1x.jpg"
              src2="contrology-chair3@2x.jpg"
              alt="Detail photo of Contrology Arm Chair"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-chair4@1x.jpg"
              src2="contrology-chair4@2x.jpg"
              alt="Close-up photo of man using Contrology Arm Chair"
              caption="Shown with optional Foam Wedge"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-chair5@1x.jpg"
              src2="contrology-chair5@2x.jpg"
              alt="In-use photo of Contrology Arm Chair"
            />
            <!-- <photo
              @setFeature="setFeatureImg"
              src="contrology-chair6@1x.jpg"
              src2="contrology-chair6@2x.jpg"
              alt="In-use photo of Contrology Arm Chair"
            /> -->
          </photo-grid>

          <!-- <cta-button class="cta-button wide" /> -->

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology<sup>®</sup> Arm Chair</h2>
              <!-- <h3></h3> -->
              <p>
                Designed to strengthen the arms, upper body and core, and promote good posture, the Contrology Arm Chair is an effective and versatile apparatus that fits well in home or studio.
                <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span>
              </p>
              <div v-show="show">
                <p>Specially-developed arm springs provide the authentic feel of the original Pilates chair. The premium upholstered padding is made of dense, resilient foam, for maximum feedback during use.  The Contrology Arm Chair conforms to the original specifications.
                <!-- <p>Please review <a href="https://s3.amazonaws.com/s3.pilates.com/resources/Contrology_WeightLimits_CapitalEquipment.pdf" class="content-link">equipment weight limits</a>. -->
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
              additionalText="33-day lead time"
            />

            <!-- Patent info -->
            <p class="part-number patent-info">
              <a href="https://www.pilates.com/company/balanced-body-patent-data">Click here</a> for <span style="font-weight: 500;">Balanced Body Patent Data</span>.
            </p>

            <section class="links">
              <icon-link
                url="https://www.pilates.com/store/returns-and-warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >Limited 10-Year Warranty</icon-link>
              <icon-link
                url="support-armchair"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
              <icon-link
                img="icon-upholstery.svg"
                alt="Upholstery icon"
              >Stock Upholstery: Black</icon-link>
              <icon-link
                img="icon-upholstery-colors.svg"
                alt="Color upholstery icon"
                title="Open modal"
                url="#"
                @open="showCardModal = true"
              >Upholstery Options</icon-link>
              <icon-link
                url="#accessories"
                title="See the accessories"
                img="icon-accessories.svg"
                alt="Accessories icon"
              >Accessories</icon-link>
            </section>

            <modal-card-large v-if="showCardModal" @close="showCardModal = false" />

            <!-- <cta-button class="cta-button" /> -->
          </div>
        </div>

        <section class="product-info">
          <prod-accordion class="accordion-wrapper" title="Features" animation="reveal">
            <ul class="features">
              <li>Handcrafted strong maple frame upholstered with thin, dense, resilient foam that allows for maximum feedback while exercising</li>
              <li>Movable seat back tilts forward for additional core stabilization</li>
              <li>A (hidden) removable stopper in back frame allows for further reclining extension</li>
              <li>2 custom arm springs provide just the right resistance and feature signature leather and contoured wood handles</li>
              <li>Optional foam wedge to adjust seat higher, and create level surface for kneeling during the Swakate Series</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Dimensions" animation="reveal">
            <p><b>Length in normal position:</b></p>
            <p>41.5” (105.4cm)</p>
            <p>Width: 16.5” (42cm)</p>
            <p>Height: 33.63” (85.4cm)</p>
            <p>Height of seat pad: approximately 10.5” (26.7cm)</p>
            <p>Weight: 34lbs. (15.4kg)</p>
          </prod-accordion>

          <tabs>
            <tab name="Features" :selected="true">
              <ul class="features">
                <li>Handcrafted strong maple frame upholstered with thin, dense, resilient foam that allows for maximum feedback while exercising</li>
                <li>Movable seat back tilts forward for additional core stabilization</li>
                <li>A (hidden) removable stopper in back frame allows for further reclining extension</li>
                <li>2 custom arm springs provide just the right resistance and feature signature leather and contoured wood handles</li>
                <li>Optional foam wedge to adjust seat higher, and create level surface for kneeling during the Swakate Series</li>
              </ul>
            </tab>
            <tab name="Dimensions" class="dims" style="margin-left: 5px;">
              <p><b>Length in normal position:</b></p>
              <p>41.5” (105.4cm)</p>
              <p>Width: 16.5” (42cm)</p>
              <p>Height: 33.63” (85.4cm)</p>
              <p>Height of seat pad: approximately 10.5” (26.7cm)</p>
              <p>Weight: 34lbs. (15.4kg)</p>
            </tab>
          </tabs>
        </section>
      </div>

      <section class="accessories-wrapper" id="accessories">
        <h2>Accessories for Contrology Arm Chair</h2>
        <div class="accessories">
          <accessory-card
            url="foam-wedge"
            product="Arm Chair"
            src="chair-wedge1@1x.jpg"
            src2="chair-wedge1@2x.jpg"
            alt="Foam Wedge product photo"
            caption="Foam Wedge"
          />
          <accessory-card
            url="arm-chair-springs"
            product="Arm Chair"
            src="armchair-springs1@1x.jpg"
            src2="armchair-springs1@2x.jpg"
            alt="Arm Chair springs close up"
            caption="Arm Chair Springs"
          />
        </div>
      </section>

      <testimonial
        src="quotebanner-armchair@1x.jpg"
        src2="quotebanner-armchair@2x.jpg"
        alt="Photo of student on a Contrology Reformer"
      >
        “The Contrology Arm Chair offers the authenticity I require and the versatility I crave to support and challenge any student.”
        <span>~<a href="https://karenfrischmann.com/" title="Learn more" target="_blank">Karen Frischmann</a></span>
      </testimonial>
    </main>
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/BKEBSUPKQhc?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
// import CtaButton from "@/components/CtaButton.vue";
import ProdAccordion from "@/components/ProdAccordion.vue";
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
import AccessoryCard from "@/components/AccessoryCard.vue";
import Testimonial from "@/components/Testimonial.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "armchair",

  metaInfo: {
    title: "Classical Pilates Chair - Contrology Arm Chair - Balanced Body",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Strengthen your arms, core and improve posture with this Pilates  Arm Chair. With its specially developer arm springs it feels like the original Pilates Chair. Shop now."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    // CtaButton,
    ProdAccordion,
    Tabs,
    Tab,
    AccessoryCard,
    Testimonial,
    Modal
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      modalExists: false, // Check featured image for video
      showModal: false, // Video modal in photogrid
      product: {
        label: "Select an Arm Chair",
        value: "",
        key: "name"
      },
      option1: {
        label: "Select a Color",
        value: "",
        key: "color"
      },
      option2: {
        label: "Select a Handle",
        value: "",
        key: "handle"
      },
      products: [
        // Product options
        {
          prodid: 41278357078209,
          partnumber: 17011,
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Black Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278357012673,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Adobe White Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278357143745,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Burgundy Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278357209281,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Dark Cherry Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278357274817,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Greystone Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278357340353,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Oak Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278357405889,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Sage Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278357471425,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Storm Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278357536961,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Wedgewood Upholstery",
          handle: "Leather Straps and Wood (Stock)",
          available: true
        },
        {
          prodid: 41278357110977,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Black Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278357045441,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Adobe White Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278357176513,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Burgundy Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278357242049,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Dark Cherry Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278357307585,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Greystone Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278357373121,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Oak Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278357438657,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Sage Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278357504193,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Storm Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        },
        {
          prodid: 41278357569729,
          partnumber: "17011C",
          price: 1650,
          name: "Contrology Arm Chair",
          color: "Wedgewood Upholstery",
          handle: "Vintage Wire and Wood",
          available: true
        }
      ]
    };
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    },

    // Does featured image include a video?
        initModal() {
      this.modalExists = true;
    },

    // Open modal from featured image
    openModal() {
      if ( this.modalExists ) {
        this.showModal = true;
        this.modalExists = false // Reset prop
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.product-info {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid #010101;
  margin-top: 30px;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  color: #333;
}

.features li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-basic.svg")
    no-repeat left center;
  padding-left: 20px;
}

.included li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-feature.svg")
    no-repeat left center;
  padding-left: 40px;
}

li {
  border-bottom: 1px solid #c4c4c4;
  padding-top: 10px;
  padding-bottom: 10px;
}

li:last-of-type {
  border-bottom: none;
}

.accordion-wrapper p {
  margin-left: 30px;
}

.tabs-wrapper {
  display: none;
}

.accessories-wrapper {
  margin-top: 30px;
}

.accessories-wrapper h2 {
  margin: 2.5rem 0 1.5rem;
}

.accessories {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.patent-info {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 3;
  order: 3;
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
  margin-bottom: 12px;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 130%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
  }

  .tabs-wrapper {
    display: block;
    max-width: 810px;
    margin: auto auto 50px;
  }

  .dims {
    max-width: 650px;
    margin: 0 auto;
  }

  .dims table {
    border-collapse: collapse;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    line-height: 1.25;
    color: #000;
    font-size: 0.75em;
    margin: 13px auto 0;
  }

  .dims th,
  .dims td {
    text-align: left;
    width: 20%;
    padding: 5px 10px;
    border: 1px solid #c4c4c4;
  }

  .dims td {
    height: 50px;
  }

  .dims tr th:first-of-type,
  .dims tr td:first-of-type {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .product-info {
    border: none;
    box-shadow: none;
  }

  li:last-of-type {
    border-bottom: 1px solid #c4c4c4;
  }

  .accordion-wrapper {
    display: none;
  }

  .accessories {
    flex-flow: row nowrap;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 0;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  ::v-deep .modal-card-wrapper {
    top: 85%;
  }

  .icon-link {
    margin: 0;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .product-info {
    grid-column: 2 / span 1;
    grid-row: 2 / span 3;
    margin-right: 30px;
    margin-top: 5px;
    max-width: 512px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 40%;
  }

  .icon-link {
    margin: 1px;
    height: 27px;
  }

  ::v-deep .tabs-details {
    background-color: transparent;
    padding: 10px 0 0;
  }
}
</style>
